/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Case_Number_HintInputs */

const en_case_field_case_number_hint = /** @type {(inputs: Case_Field_Case_Number_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-assigned when you create the case.`)
};

const pt_br2_case_field_case_number_hint = /** @type {(inputs: Case_Field_Case_Number_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerado automaticamente ao criar o caso.`)
};

/**
* | output |
* | --- |
* | "Auto-assigned when you create the case." |
*
* @param {Case_Field_Case_Number_HintInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_case_number_hint = /** @type {((inputs?: Case_Field_Case_Number_HintInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Case_Number_HintInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_case_number_hint(inputs)
	return pt_br2_case_field_case_number_hint(inputs)
});